import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, unref as _unref, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/logo.png'
import _imports_1 from '../images/emart-shop-title.png'
import _imports_2 from '../images/icon-search-black.png'


const _withScopeId = n => (_pushScopeId("data-v-55bbf504"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "page" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "logo"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "title"
  })
], -1))
const _hoisted_5 = { class: "search-wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "icon-search"
}, null, -1))
const _hoisted_7 = { class: "shop-list row" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "address" }

import { ref } from 'vue';
  import { EMartShopList, EMartShopListType } from './shop-list';
  import { useI18n } from 'vue-i18n';
  import _ from 'lodash';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();

  const eMartShopList = ref<EMartShopListType[]>(EMartShopList);
  const keywork = ref('');

  const handleSearch = _.debounce(function() {
    const text = keywork.value;
    if (!text) {
      return eMartShopList.value = EMartShopList;
    }
    eMartShopList.value = EMartShopList.filter(({ address, name }) => {
      return address.includes(text) || name.includes(text);
    });
  }, 200);

return (_ctx: any,_cache: any) => {
  const _component_AppEmptyView = _resolveComponent("AppEmptyView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keywork).value = $event)),
            type: "text",
            placeholder: "매장명 검색",
            class: "input",
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(handleSearch) && _unref(handleSearch)(...args)))
          }, null, 544), [
            [
              _vModelText,
              keywork.value,
              void 0,
              { trim: true }
            ]
          ]),
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eMartShopList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "item col-12 col-md-6"
          }, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.address), 1)
          ]))
        }), 128))
      ]),
      (!eMartShopList.value.length)
        ? (_openBlock(), _createBlock(_component_AppEmptyView, {
            key: 0,
            text: _unref(t)('No search results'),
            mode: "search"
          }, null, 8, ["text"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})